import { Image, Col, Row } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import moment from "moment";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const SingleCampaign = (
  { CampaignDetails }: { CampaignDetails: any },
  props: any
): ReactElement => {
  const [getCampaignDetails, setCampaignDetails] = useState(undefined);

  useEffect(() => {
    setCampaignDetails(CampaignDetails);
  }, [CampaignDetails]);

  return (
    <React.Fragment>
      <Row gutter={20}>
        <Col span={24}>
          <Image src={getCampaignDetails?.banner} className="rounded" />
        </Col>
        <Col span={24}>
          <h3 className="title mt-4">Basic Information</h3>
          <div className="inner-body-wrapper">
            <div className="inner-body">
              <div className="single">
                <div className="info-name">
                  <span>Campaign ID</span>
                </div>

                <div className="info-desc">
                  <span>{getCampaignDetails?.id}</span>
                </div>
              </div>
              <div className="single">
                <div className="info-name">
                  <span>Campaign Name</span>
                </div>
                <div className="info-desc">
                  <span>{getCampaignDetails?.name}</span>
                </div>
              </div>
              <div className="single">
                <div className="info-name">
                  <span>Campaign Description</span>
                </div>
                <div className="info-desc">
                  <span>{getCampaignDetails?.description}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Campaign Start Date</span>
                </div>
                <div className="info-desc">
                  <span>
                    {moment(getCampaignDetails?.startAt).format("lll")}
                  </span>
                </div>
              </div>
              <div className="single">
                <div className="info-name">
                  <span>Campaign End Date</span>
                </div>
                <div className="info-desc">
                  <span>{moment(getCampaignDetails?.endAt).format("lll")}</span>
                </div>
              </div>
              <div className="single">
                <div className="info-name">
                  <span>Display Order</span>
                </div>
                <div className="info-desc">
                  <span>{getCampaignDetails?.displayOrder}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Type</span>
                </div>
                <div className="info-desc">
                  <span>{getCampaignDetails?.type?.replace("_", " ")}</span>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
SingleCampaign.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default SingleCampaign;
